import React, { useContext, useState, useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { getPeriods } from '../../../services/documentsService';

import { DropDownList, DropDownListChangeEvent } from '@progress/kendo-react-dropdowns';

import FilterCtx from '../../../../context/filterContext/filterCtx';
import { RootState } from '../../../../redux/store';
import { POPUP } from '../../../../redux/types';

import { IPeriodsFilter } from '../../types/IPeriodsFilter';

import { Switch } from '@progress/kendo-react-inputs';

import '../../dropdown/dropdown.scss';
import '../filters.scss';

const defaultPeriod = {
  name: 'Period',
  endDate: null,
  periodNumber: null,
  startDate: null,
  year: null,
};

const PeriodsFilter: React.FC<IPeriodsFilter> = ({ toggleOn }) => {
  const [value, setValue] = useState<any>(null);
  const [checked, setChecked] = useState<boolean>(false);
  const [periods, setPeriods] = useState<any[]>([]);

  const dispatch = useDispatch();
  const filterCtx: any = useContext(FilterCtx);

  const impersonation = useSelector((state: RootState) => state.impersonate);

  const handlePeriodToggleChange = (e): void => {
    setChecked(e.value);
    filterCtx.setPeriodToggle(e.value);
    filterCtx.setPeriod('');
    setValue(null);
    let tempArray = filterCtx.slicerChoices;
    let tempGroupsArray = filterCtx.initialGroup;
    if (e.value) {
      filterCtx.setSlicerChoices([...filterCtx.slicerChoices, 'period']);
      filterCtx.setInitialGroup([...filterCtx.initialGroup, { field: 'period' }]);
    } else {
      tempArray = filterCtx.slicerChoices.filter((item) => item !== 'period');
      tempGroupsArray = filterCtx.initialGroup.filter((item) => item.field !== 'period');
      filterCtx.setSlicerChoices(tempArray);
      filterCtx.setInitialGroup(tempGroupsArray);
    }
  };

  const handlePeriodChange = (event: DropDownListChangeEvent): void => {
    setValue(event.value && event.value);
  };

  useEffect(() => {
    setChecked(filterCtx.slicerChoices.indexOf('period') + 1 > 0);
    getPeriods(3).then((res) => {
      let tempPeriods = [];
      res.data.forEach((period) => {
        tempPeriods.push(period);
      });
      setPeriods(tempPeriods);
    }).catch((err) => dispatch({ type: POPUP.SET_SERVER_ERROR, payload: err.message }));

    if (filterCtx.period) {
      setValue(filterCtx.period);
    }
  }, [impersonation]);

  useEffect(() => {
    filterCtx.setPeriod(value);
  }, [value]);

  return (
    <div className='periods-filter-wrapper pointer'>
      <DropDownList
        className={toggleOn && checked ? 'custom-dropdown-style filters-dropdown multiselect-padding-left' : 'filters-dropdown custom-dropdown-style'}
        data={periods}
        value={value}
        defaultValue={value ? value : defaultPeriod}
        defaultItem={defaultPeriod}
        textField='name'
        dataItemKey='startDate'
        disabled={toggleOn && checked}
        onChange={handlePeriodChange}
      />
      {toggleOn && checked && filterCtx.slicerChoices.indexOf('period') + 1 > 0 && (
        <div className='switch-number-container'>
          <span>{filterCtx.slicerChoices.indexOf('period') + 1}</span>
        </div>
      )}
      {toggleOn && (
        <div className='switch-container'>
          <Switch onLabel={''} offLabel={''} checked={checked} onChange={handlePeriodToggleChange} />
        </div>
      )}
    </div>
  );
};

export default PeriodsFilter;
